// extracted by mini-css-extract-plugin
module.exports = {"container":"TransitionComponent_container__SKjIR"};